import MProfile from "../../component/mobile/profile/MProfile";
import Profile from "../../component/profile/Profile";


const PROFILE=()=>{
  return(
    <div className="PROFILE">
      {window.innerWidth>1000 &&<Profile/>}
      {window.innerWidth<1000 &&<MProfile/>}
    </div>
  )
}

export default PROFILE;